   export default function({ app, redirect,req }) {
     app.router.beforeEach((to, from, next) => {
       if (!to.matched.length) {
         // 如果没有匹配的路由，进行自定义处理
         redirect('/'); // 可以重定向到首页或其他页面
         return;
       }
       next();
     });
   }